// Meta Pixel event helper — safe no-op when fbq isn't loaded (adblock, dev).
export function trackMetaEvent(event, params) {
  try {
    if (typeof window.fbq === "function") window.fbq("track", event, params || {});
  } catch (_e) { /* ignore */ }
}
